export const GET_CLIENTS = 'sagas/client/GET_CLIENTS';
export const GET_CLIENT = 'sagas/client/GET_CLIENT';
export const CREATE_CLIENT = 'sagas/client/CREATE_CLIENT';
